import React from "react";
import {StyleSheet, View, Text, Dimensions} from "react-native";
import {Color, globalFontStyle, Font} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import FastImage from "../../../common/FastImage";
import MultiChild from "./MultiChild";
import {isMobile} from "../../../utils/commonMethods";
import {tip_image, defaulteventimage} from "../../../utils/images";
import { getSubcategoryImage } from "../../../utils/subcategoryImages";
import TimerComp from "../../../commonComponents/TimerComp";
import ParentProbeCard from "./parentProbeCard";
import {Image} from 'expo-image';
import {
  globalConfigurableData,
  GlobalScreens,
} from "../../../utils/globalConstant";

const MultiCard = props => {
  const {
    trade,
    live = null,
    mulitOptionList = [],
    isContestCard = false,
    onCallback,
    isParticipent,
    contestStartTime,
    timerExpireCallback = () => {},
    liveStatsId,
  } = props;

  const onCallback1 = () => {
    onCallback(trade);
  };

  const t = trade;

  // Get screen width
  const screenWidth = Dimensions.get('window').width;

  // Calculate image size based on screen width
  const getImageSize = () => {
    if (screenWidth < 768) { // mobile
      return 65;
    } else if (screenWidth < 1024) { // tablet
      return 55;
    } else { // web
      return 65;
    }
  };

  const imageSize = getImageSize();

  return (
    <View>
      <View
        style={[
          styles.cardContainer,
          GlobalScreens.Home?.mCardBorder
            ? { borderColor: GlobalScreens.Home?.mCardBorder }
            : {},
          isMobile() && styles.mobileCardContainer
        ]}>
        <View style={[
          { minHeight: 115, justifyContent: 'space-between' },
          isMobile() && styles.mobileInnerContainer
        ]}>
          <View style={[styles.upperRow, isMobile() && styles.mobileUpperRow]}>
            <View style={styles.imageContainer}>
              <Image
                style={[
                  styles.cardImg,
                  { width: imageSize, height: imageSize },
                  isMobile() && styles.mobileCardImg
                ]}
                source={{
                  uri: t?.imageurl || getSubcategoryImage(t?.subcategory) || defaulteventimage(),
                }}
                contentFit="cover"
                transition={1000}
              />
              <TimerComp
                end_time={t?.endsat}
                isHome={'home'}
                timerExpireCallback={timerExpireCallback}
                customStyle={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: '#FF3B30',
                  paddingVertical: 6,
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderBottomLeftRadius: 4,
                  borderBottomRightRadius: 4,
                  flexDirection: 'row',
                  isStrip: true,
                  marginTop: 0,
                  marginBottom: 0,
                  marginHorizontal: 0,
                  borderTopWidth: 0,
                }}
              />
            </View>
            <View style={[styles.contentContainer, isMobile() && styles.mobileTextContainer]}>
              <View style={styles.titleContainer}>
                <Text
                  style={[
                    globalFontStyle.appFontHeading,
                    {
                      color: globalConfigurableData.primaryTextColor1,
                      flexWrap: 'wrap',
                      flex: 1,
                      marginRight: 16,
                      ...(isMobile() && {
                        fontSize: Font.fontSize16,
                        lineHeight: 22,
                      }),
                    },
                  ]}
                  numberOfLines={2}>
                  {t?.title}
                </Text>
                {t?.subtitle && t?.subtitle.trim() && (
                  <Text
                    style={[
                      globalFontStyle.appFontHeadingSubtitle,
                      { 
                        color: globalConfigurableData.primaryTextColor1, 
                        marginTop: 4,
                        ...(isMobile() && {
                          fontSize: Font.fontSize16,
                          lineHeight: 22,
                        }),
                      },
                    ]}
                    numberOfLines={1}>
                    {t?.subtitle}
                  </Text>
                )}
              </View>
            </View>
          </View>
          {mulitOptionList?.map((item, index) => {
            return (
              <ParentProbeCard
                trade={item}
                key={index}
                isContestCard={isContestCard}
                onCallback={onCallback1}
                isMulti={true}
                isParticipent={isParticipent}
                contestStartTime={contestStartTime}
                liveStatsId={liveStatsId}
              />
            );
          })}
        </View>
        {t?.tooltip !== "" && t?.tooltip && (
          <View style={styles.tipContainer}>
            <FastImage
              style={styles.volStyle}
              source={globalConfigurableData.tooltip()}
            />
            <Text
              style={[
                globalFontStyle.appFontSubText,
                {color: GlobalScreens.Event.tipColor, textAlign: "center"},
              ]}>
              {t?.tooltip}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

export default MultiCard;

const styles = StyleSheet.create({
  cardImg: {
    borderRadius: 4,
    overflow: 'hidden',
  },
  volStyle: {
    width: 17,
    height: 17,
    marginRight: 5,
  },
  cardContainer: {
    borderColor: GlobalScreens.Event.borderColor,
    backgroundColor: globalConfigurableData.cardBgColor,
    marginTop: isMobile() ? 15 : 20,
  },
  upperRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  tipContainer: {
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: GlobalScreens.Event.tipBackgroundColor,
    paddingVertical: 8,
    paddingHorizontal: 15,
    marginTop: 20,
    marginBottom: -15,
    marginHorizontal: -15,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  mobileCardContainer: {
  },
  mobileInnerContainer: {
    minHeight: 100,
  },
  mobileUpperRow: {
    marginBottom: 12,
  },
  mobileCardImg: {
    borderRadius: 4,
  },
  mobileTextContainer: {
    marginLeft: 16,
  },
  contentContainer: {
    flex: 1,
    marginLeft: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleContainer: {
    flex: 1,
  },
  imageContainer: {
    position: 'relative',
  },
});
